import styled from "styled-components";

import CellBox from "../../../../components/CellBox";
import List from "../../../../components/List";
import { Tabs } from "antd-mobile";
import "./style.css";
import useAccount from "../../hook";
import { hideAccount, fmoney } from "../../../../utils/utils";
import { useMemo } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import useLayout from "../../../../hooks/Layout/useLayout";

export default function WalletTab() {
  const { getHistoryRecord, getBalances, myAccount } = useAccount();
  const { navigateTo } = useLayout()
  const [loading, setLoading] = useState(true);
  const [balances, setBalances] = useState({
    RB: 0,
    RBCT: 0,
    RBET: 0,
    USDT: 0,
  });
  const intl = useIntl();

  const cellData = useMemo(
    () => [
      {
        icon: "/image/RB.png",
        label: "RT",
        text: fmoney(balances.RB, 2),
        onClick: () => {
          navigateTo("/rb");
        },
      },
      {
        icon: "/image/USDT.png",
        iconStyle: {
          width: "2.5rem",
          marginRight: "1.0rem",
          border: "1px solid",
          padding: "2px",
          borderRadius: "50%",
        },
        label: "USDT",
        text: fmoney(balances.USDT, 3),
      },
      {
        icon: "/image/quility_chip.png",
        label: intl.formatMessage({
          id: "pages.account.wallet_card_chip",
          defaultMessage: "属性卡碎片",
        }),
        text: fmoney(balances.RBCT, 2),
      },
      {
        icon: "/image/equip_chip.png",
        label: intl.formatMessage({
          id: "pages.account.wallet_equip_chip",
          defaultMessage: "装备碎片",
        }),
        text: fmoney(balances.RBET, 2),
      },
    ],
    [balances]
  );

  const [unCompleteData, setUnCompleteData] = useState([]);
  const [histroyData, setHistroyData] = useState([]);
  const navigate = useNavigate();
  const unCompleteHeader = [
    {
      prop: "tx_hash",
      render: (val) => {
        return hideAccount(val);
      },
    },
    {
      prop: "amount",
      render: (val) => {
        return val;
      },
    },
    {
      prop: "date",
      render: (val) => {
        return val;
      },
    },
  ];
  const histroyHeader = [
    {
      prop: "tx_hash",
      width: "26%",
      render: (val) => {
        return <div >{hideAccount(val)}</div>;
      },
    },
    {
      prop: "value",
      width:'20%',
      render: (val, row) => {
        return (
          <div  style={{ color: "#FF5C00",    display: 'flex', alignItems: 'center'}}>
            
            {row.currency === 1 ? (
              <img style={{width:'1.2rem',marginRight:'3px' }} src="/image/RB.png" alt="rb" />
            ) : row.currency === 2 ? (
              <img style={{width:'1.2rem',marginRight:'3px' }} src="/image/quility_chip.png" alt="rbct" />
            ) : (
              <img style={{width:'1.2rem',marginRight:'3px'}} src="/image/equip_chip.png" alt="rbet" />
            )}
            
            {val > 0 ? " + " : " - "}
            {fmoney(Math.abs(val), 2)}
          </div>
        );
      },
    },
    {
      prop: "tx_method",
      width:'28%',
      render: (val) => {
        return <div style={{ color: "#FF5C00" }}>{val}</div>;
      },
    },
    {
      prop: "create_time",
      render: (val) => {
        return val.split(" ")[0];
      },
    },
  ];

  useEffect(() => {
    if (myAccount && myAccount.account) {
      console.log("wallet tab history");
      changeTab("histroy");
      getBalances().then((res) => {
        setBalances(res);
      });
    }
  }, [myAccount]);
  const changeTab = async (key) => {
    setLoading(true);
    if (key === "unComplete") {
    }
    if (key === "histroy") {
      const histroies = await getHistoryRecord();
      setHistroyData(histroies.data.list);
    }
    setLoading(false);
  };
  return (
    <>
      <Container>
        <Flex style={{ marginBottom: "1.0rem" }}>
          <img
            className="avatar"
            style={{ width: "3.8rem" }}
            src="/image/default_avatar.png"
            alt="avatar"
          />
          <Text>
            {intl.formatMessage({
              id: "pages.account.wallet_statistics",
              defaultMessage: "賬戶總覽",
            })}
          </Text>
        </Flex>
        <CellBox list={cellData} />
        <Tabs
          className="tab1-tabs"
          defaultActiveKey={"histroy"}
          onChange={changeTab}
        >
          {/* <Tabs.Tab title="未完成" key="unComplete" >
            <List list={unCompleteData} header={unCompleteHeader} style={{minHeight: '30vh'}} />
          </Tabs.Tab> */}
          <Tabs.Tab
            title={intl.formatMessage({
              id: "pages.account.wallet_record",
              defaultMessage: "歷史記錄",
            })}
            key="histroy"
          >
            <List
              style={{ marginTop: "1.0rem", minHeight: "30vh" }}
              loading={loading}
              list={histroyData}
              header={histroyHeader}
            />
          </Tabs.Tab>
        </Tabs>
      </Container>
    </>
  );
}

const Container = styled.div`
  padding: 2.0rem .7rem;
`;
const Text = styled.div`
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 2.0rem;
  display: inline-block;
  vertical-align: super;
  margin-left: 1.0rem;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
`;
